import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore.js";
import Button from "../common/Button";
import SectionCard from "./AccounSettingSectionCard";
import InfoRow from "./InfoRow";

const AccountInfo = ({ userRole }) => {
  const user = useAuthStore(s => s.user);
  const navigate = useNavigate();
  const isRecruiter = userRole === "recruiter";
  const editProfilePath = isRecruiter ? "/company-profile" : "/manage-profile";

  return (
    <div className="space-y-6">
      <SectionCard title="Account Overview">
        <div className="space-y-4">
          <InfoRow
            label="Account Type"
            value={
              user?.role
                ? user.role.charAt(0).toUpperCase() + user.role.slice(1)
                : "User"
            }
          />
          <InfoRow label="Email Address" value={user?.email} verified />
          {isRecruiter && (
            <InfoRow
              label="Company Name"
              value={user?.company_name || "Not set"}
            />
          )}
        </div>
      </SectionCard>
      <SectionCard title="Account Actions">
        <div className="grid sm:grid-cols-2 gap-4">
          <Button variant="outline" onClick={() => navigate(editProfilePath)}>
            Edit Profile
          </Button>
          {/* <Button
            variant="outline"
            onClick={() => navigate("/subscription-management")}
          >
            Manage Subscription
          </Button> */}
        </div>
      </SectionCard>
    </div>
  );
};

export default AccountInfo;